export const candidateDetailsSelector = state => state.candidateDetails;
